import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import styled from 'styled-components';
import { createEditorTileAssetViewer, disposeEditorTileAssetViewer, getEditorTileAssetViewer } from '../../canvas/editor/tileAssetViewer/EditorTileAssetViewer';
const Container = styled.div.withConfig({
  displayName: "EditorTileAssetViewerContainer__Container",
  componentId: "sc-1hzutl-0"
})(["padding:3px;"]);
export class EditorTileAssetViewerContainer extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "refElement", void 0);
  }

  componentDidMount() {
    createEditorTileAssetViewer();
    getEditorTileAssetViewer().attach(this.refElement);
  }

  componentWillUnmount() {
    disposeEditorTileAssetViewer();
  }

  render() {
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
      ref: ref => {
        this.refElement = ref;
        const tileAssetViewer = getEditorTileAssetViewer();
        if (!tileAssetViewer) return;

        if (ref) {
          tileAssetViewer.attach(ref);
        } else {
          tileAssetViewer.detach();
        }
      }
    }));
  }

}